<ng-container *ngIf="listOfSecondaryBrands.length < 3">
<span id="headline1" class="plusHeadline addBrand" >
  <i class="icon-add-headline" (click)="addNewBrand()"></i>
</span>
</ng-container>
<ng-container *ngFor="let addedBrand of listOfSecondaryBrands;let i = index">
  <app-secondary-brand-form [sendAddedBrand]="addedBrand" [storyEditMode]=[storyEditMode] [brandCategory]="category" 
  [brandCategories] ="categories" [brandSuggestionList1]="secondaryBrandSuggestion" [modelSuggestionList]="modelSuggestion" [listOfAllModels]="allModels"
    [index]="i" (brandChanged)="brandChangedHandler($event)">
  </app-secondary-brand-form>
    <span class="deleteHeadline" id="headline2">
      <i class="icon-delete"  (click)="deleteBrand(addedBrand)"></i>
    </span>
</ng-container>
